import mapCodes from './aibaMapCodes.json';

export function inspectMapCode(code: string) {
  const [areaCode, damageCode, severityCode] = code.split('.');
  const mapValue = {
    areaValue: mapCodes.Area[areaCode as keyof typeof mapCodes.Area] || '',
    damageValue:
      mapCodes.Damage[damageCode as keyof typeof mapCodes.Damage] || '',
    severityValue:
      mapCodes.Severity[severityCode as keyof typeof mapCodes.Severity] || '',
  };
  return mapValue;
}
